/* eslint-disable max-len */
export const isValidEmail = (email: string) =>
  /^[a-zA-Z0-9.+_{|}-]{1,60}@[a-zA-Z0-9-_+]{1,60}\.[a-zA-Z0-9]{1,60}(?:\.[a-zA-Z0-9-_+]{0,30}[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,60}[a-zA-Z0-9])?)*$/.test(
    email,
  );

export const isValidPassword = (password: string) => password.length >= 6 && password.length <= 60;

export const isNumber = (value: any): boolean => !value.isNaN;
